export const CIC_EXPERIENCE_COMPARED = {
    better: {
        en: 'Better than my experiences elsewhere',
        es: 'Mejor que mis experiencias en otros lugares'
    },
    same: {
        en: 'More or less the same as my experiences elsewhere',
        es: 'Más o menos igual que mis experiencias en otros lugares'
    },
    worse: {
        en: 'Worse than my experiences elsewhere',
        es: 'Peor que mis experiencias en otros lugares'
    },
    idk: {
        en: "I'm not sure",
        es: 'No estoy seguro'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
